module.exports = __webpack_public_path__ + "static/media/cc.e4a9501b.svg";